import React from 'react'

import TugasTambahanApp from 'app/KinerjaPage/pages/Pelaksanaan/TugasTambahan'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { PageGuardPelaksanaanDate } from 'app/KinerjaPage/pages/PelaksanaanV2/components/PageGuardPelaksanaanDate'
import { useNewDocumentFlow } from 'app/KinerjaShared/hooks/useNewDocumentFlow'
import { NotFoundError } from 'utils/customError'

import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    _context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const isKinerjaEnabled = toggle?.['kinerja-enabled'] || false
    const isKinerjaPelaksanaanEnabled =
      toggle?.['kinerja-pelaksanaan-enabled'] || false

    if (!isKinerjaEnabled || !isKinerjaPelaksanaanEnabled) {
      return {
        redirect: {
          destination: '/404',
          permanent: false,
        },
      }
    }
  },
})

const TugasTambahan = () => {
  const { status } = useNewDocumentFlow()

  if (status !== 'OLD_DOCUMENT_FLOW') {
    throw new NotFoundError('', 'Not Found')
  }

  return (
    <PageGuardPelaksanaanDate>
      <TugasTambahanApp />
    </PageGuardPelaksanaanDate>
  )
}

TugasTambahan.Layout = KinerjaLayout

TugasTambahan.layoutOpts = {
  hasHeader: true,
}

export default TugasTambahan
